import React from 'react';

const TenantName = ({ name }) => <h3>{name}</h3>;

export default TenantName;
